/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { DEFAULT_ZOOM_IN_FACTOR, DEFAULT_ZOOM_OUT_FACTOR } from './timeZoomUtils';

const DEFAULT_PAN_UP_RANGE_RATIO = 0.25;
const DEFAULT_PAN_DOWN_RANGE_RATIO = -0.25;
const DEFAULT_PAN_START_RANGE_RATIO = 0.25;
const DEFAULT_PAN_END_RANGE_RATIO = -0.25;

type KbPanEvent = CustomEvent<{ rangeRatio: number }>;
type KbZoomEvent = CustomEvent<{ zoomFactor: number }>;

const createKbPanUpEvent = () =>
  new CustomEvent('KbPanVertical', { detail: { rangeRatio: DEFAULT_PAN_UP_RANGE_RATIO } });

const createKbPanDownEvent = () =>
  new CustomEvent('KbPanVertical', { detail: { rangeRatio: DEFAULT_PAN_DOWN_RANGE_RATIO } });

const createKbPanStartEvent = () =>
  new CustomEvent('KbPanHorizontal', { detail: { rangeRatio: DEFAULT_PAN_START_RANGE_RATIO } });

const createKbPanEndEvent = () =>
  new CustomEvent('KbPanHorizontal', { detail: { rangeRatio: DEFAULT_PAN_END_RANGE_RATIO } });

const createKbZoomInEvent = () =>
  new CustomEvent('KbZoomIn', { detail: { zoomFactor: DEFAULT_ZOOM_IN_FACTOR } });

const createKbZoomOutEvent = () =>
  new CustomEvent('KbZoomIn', { detail: { zoomFactor: DEFAULT_ZOOM_OUT_FACTOR } });

export {
  type KbPanEvent,
  createKbPanUpEvent,
  createKbPanDownEvent,
  createKbPanStartEvent,
  createKbPanEndEvent,
  type KbZoomEvent,
  createKbZoomInEvent,
  createKbZoomOutEvent
};
